import { render, staticRenderFns } from "./ReviewTagsSettingsPanel.vue?vue&type=template&id=53ac660d&"
import script from "./ReviewTagsSettingsPanel.vue?vue&type=script&lang=js&"
export * from "./ReviewTagsSettingsPanel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports